<ng-template #projectedContent>
  <ng-content />
</ng-template>

@if (showCard()) {
  <div class="hero-card">
    <ng-container *ngTemplateOutlet="projectedContent" />
  </div>
} @else {
  <div class="hero-plain">
    <ng-container *ngTemplateOutlet="projectedContent" />
  </div>
}
